import React from 'react';

import { useSelector } from 'react-redux';
import { selectIsClimate } from '../../store/options/options.selector';
import {
  selectChartTab,
  selectIsChartVisible,
} from '../../store/ui/ui.selector';

import ThemeSelector from '../theme-selector/theme-selector.component';
import AttributeSelector from '../attribute-selector/attribute-selector.component';
import MetricSelector from '../metric-selector/metric-selector.component';
import DateSlider from '../date-slider/date-slider.component';
import DateClimateModel from '../date-climate-model/date-climate-model.component';
import Section from '../section/section.component';

import './options-panel.styles.scss';
import { Typography } from '@mui/material';

export default function OptionsPanel() {
  const isClimate = useSelector(selectIsClimate);
  const chartTab = useSelector(selectChartTab);
  const isChartVisible = useSelector(selectIsChartVisible);

  return (
    <div className='options-panel-container'>
      <Section className='options-panel-content'>
        <Typography variant='h5' component='h2'>
          Selection Panel
        </Typography>
        <div className='options-panel-options'>
          <ThemeSelector />
          <AttributeSelector />
          {!isClimate && <MetricSelector />}
          {isClimate && isChartVisible && chartTab !== 'historical' ? (
            <DateClimateModel />
          ) : (
            <DateSlider />
          )}
        </div>
      </Section>
    </div>
  );
}
